import common from "./common/zh_tw.yml";
import form from "./form/zh_tw.yml";
import formError from "./formError/zh_tw.yml";
import hotel from "./hotel/zh_tw.yml";
import hotelWaitingList from "./hotelWaitingList/zh_tw.yml";
import activity from "./activity/zh_tw.yml";
import camp from "./camp/zh_tw.yml";
import booking from "./booking/zh_tw.yml";
import bookingActivity from "./bookingActivity/zh_tw.yml";
import bookingCamp from "./bookingCamp/zh_tw.yml";
import checkIn from "./checkIn/zh_tw.yml";
import user from "./user/zh_tw.yml";
import top from "./top/zh_tw.yml";

export const labelZhTw: any = {
  common: common["zh_tw"]["labelCommon"],
  form: form["zh_tw"]["labelForm"],
  formError: formError["zh_tw"]["labelFormError"],
  hotel: hotel["zh_tw"]["labelHotel"],
  hotelWaitingList: hotelWaitingList["zh_tw"]["labelHotelWaitingList"],
  activity: activity["zh_tw"]["labelActivity"],
  camp: camp["zh_tw"]["labelCamp"],
  booking: booking["zh_tw"]["labelBooking"],
  bookingActivity: bookingActivity["zh_tw"]["labelBookingActivity"],
  bookingCamp: bookingCamp["zh_tw"]["labelBookingCamp"],
  checkIn: checkIn["zh_tw"]["labelCheckIn"],
  user: user["zh_tw"]["labelUser"],
  top: top["zh_tw"]["labelTop"],
};
